import React from 'react';
import styles from './Popup.module.css';

const Popup = ({ message, onClose }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <h2>Score</h2>
        <p>{message}</p>
        <button onClick={onClose} >Close</button>
      </div>
    </div>
  );
};

export default Popup;